import {Observable}    from 'rxjs';
import {filter, mapTo} from 'rxjs/operators';

import SyntheticMediaEventType   from '../Constants/SyntheticMediaEventType';
import IMediaEventsStreamPayload from '../Interfaces/IMediaEventsStreamPayload';

const createPlayRejectionStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>
): Observable<void> =>
    mediaEvents$
        .pipe(
            filter(({type}) => type === SyntheticMediaEventType.AUTOPLAY_REJECTION),
            mapTo<IMediaEventsStreamPayload, void>(void 0)
        );

export default createPlayRejectionStream;